module.exports = __webpack_public_path__ + "img/air-compressors.2fb85419.svg";